import * as React from "react";
import { Link } from "@/components/common/Link";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const cookiesData = [{
  category: "Essenziali e Tecnici",
  examples: "session_id, csrf_token, cart_id",
  purpose: "Strettamente necessari per il funzionamento del sito, la navigazione sicura e la gestione del carrello degli acquisti. Senza questi cookie, i nostri dolci non potrebbero raggiungerti online.",
  duration: "Sessione"
}, {
  category: "Prestazioni e Analisi",
  examples: "_ga, _gid (Google Analytics)",
  purpose: "Ci aiutano a capire come i visitatori interagiscono con la nostra pasticceria digitale, raccogliendo dati anonimi per migliorare costantemente la tua esperienza di navigazione.",
  duration: "Fino a 2 anni"
}, {
  category: "Funzionalità",
  examples: "language_pref, user_location",
  purpose: "Permettono al sito di ricordare le tue preferenze, come la lingua o la regione, per offrirti un servizio più fluido e personalizzato ad ogni tua visita.",
  duration: "1 anno"
}, {
  category: "Marketing e Profilazione",
  examples: "_fbp (Meta Ads), ads/ga-audiences",
  purpose: "Utilizzati per mostrarti annunci pertinenti ai tuoi gusti e interessi su altre piattaforme, rendendo la comunicazione delle nostre creazioni più rilevante per te.",
  duration: "Fino a 1 anno"
}];
export default function CookiePolicy() {
  return <section data-section-id="226071" id="policy-overview" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="text-center mb-12 border-b border-border pb-8">
          <h1 className="font-default text-3xl md:text-5xl font-bold text-foreground mb-4">
            Informativa sui Cookie
          </h1>
          <p className="font-serif italic text-chart-2 text-lg">
            Ultimo aggiornamento: 24 Maggio 2024
          </p>
          <p className="mt-6 font-sans text-foreground/80 leading-relaxed max-w-2xl mx-auto">
            Questa Informativa spiega cosa sono i cookie, come li utilizziamo nel sito di Dolci Sapori e quali opzioni hai per gestirli. Questo documento integra la nostra Informativa sulla Privacy.
          </p>
        </div>

        <div className="space-y-12">
          <section>
            <h2 className="font-default text-2xl font-bold text-foreground mb-4">
              1. Identificazione del Titolare
            </h2>
            <ul className="list-none space-y-2 font-sans text-foreground/80 leading-relaxed">
              <li><strong>Azienda:</strong> Dolci Sapori</li>
              <li className="!font-normal">P. IVA.: 02118980842 C.F.: TLNLNS63B24I533Y</li>
              <li><strong>Sede:</strong> Sciacca (AG), Sicilia</li>
              <li><strong>Email:</strong> info@dolcisapori.eu</li>
            </ul>
          </section>

          <section>
            <h2 className="font-default text-2xl font-bold text-foreground mb-4">
              2. Cosa sono i Cookie?
            </h2>
            <p className="font-sans text-foreground/80 leading-relaxed mb-4">
              I cookie sono piccoli file di testo che vengono memorizzati sul tuo computer o dispositivo mobile quando visiti un sito web. Sono ampiamente utilizzati per far funzionare i siti in modo efficiente e fornire informazioni ai proprietari del sito. Le loro funzioni principali includono:
            </p>
            <ul className="list-disc pl-6 space-y-2 font-sans text-foreground/80 leading-relaxed">
              <li>Permettere una navigazione fluida tra le pagine del catalogo.</li>
              <li>Ricordare le tue preferenze e le impostazioni del carrello.</li>
              <li>Migliorare l'esperienza complessiva dell'utente sul sito.</li>
              <li>Garantire che le promozioni che vedi online siano in linea con i tuoi interessi.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-default text-2xl font-bold text-foreground mb-6">
              3. Tipologie di Cookie Utilizzati
            </h2>
            <p className="font-sans text-foreground/80 leading-relaxed mb-6">
              Di seguito dettagliamo le categorie di cookie che utilizziamo nel nostro sito, la loro finalità specifica e la durata tipica di conservazione.
            </p>
            
            <div className="rounded-lg border border-border overflow-hidden shadow-sm">
              <Table>
                <TableHeader className="bg-primary">
                  <TableRow className="hover:bg-primary">
                    <TableHead className="text-primary-foreground font-semibold py-4">Categoria / Esempi</TableHead>
                    <TableHead className="text-primary-foreground font-semibold py-4">Finalità</TableHead>
                    <TableHead className="text-primary-foreground font-semibold py-4 whitespace-nowrap">Durata</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody className="bg-card">
                  {cookiesData.map((cookie, i) => <TableRow key={i} data-index={i} className="border-border">
                      <TableCell className="align-top py-4">
                        <div className="font-default font-semibold text-foreground mb-1">{cookie.category}</div>
                        <div className="text-xs text-muted-foreground font-mono">{cookie.examples}</div>
                      </TableCell>
                      <TableCell className="align-top py-4 font-sans text-foreground/80 leading-relaxed">
                        {cookie.purpose}
                      </TableCell>
                      <TableCell className="align-top py-4 font-sans text-foreground/80 whitespace-nowrap">
                        {cookie.duration}
                      </TableCell>
                    </TableRow>)}
                </TableBody>
              </Table>
            </div>
          </section>

          <section>
            <h2 className="font-default text-2xl font-bold text-foreground mb-4">
              4. Gestione dei Cookie
            </h2>
            <div className="space-y-6">
              <div>
                <h3 className="font-default text-xl font-semibold text-foreground mb-2">4.1 Banner dei Cookie</h3>
                <p className="font-sans text-foreground/80 leading-relaxed mb-2">
                  Alla tua prima visita, ti verrà presentato un banner dove potrai:
                </p>
                <ul className="list-disc pl-6 space-y-2 font-sans text-foreground/80 leading-relaxed">
                  <li>Accettare tutti i cookie per l'esperienza completa.</li>
                  <li>Rifiutare i cookie non essenziali.</li>
                  <li>Personalizzare le tue preferenze in base alle categorie.</li>
                </ul>
              </div>
              <div>
                <h3 className="font-default text-xl font-semibold text-foreground mb-2">4.2 Impostazioni del Browser</h3>
                <p className="font-sans text-foreground/80 leading-relaxed mb-2">
                  Puoi configurare il tuo browser per rifiutare i cookie o avvisarti quando vengono inviati. Per maggiori informazioni sulla gestione dei cookie nei browser più diffusi, consulta:
                </p>
                <ul className="list-disc pl-6 space-y-2 font-sans text-foreground/80 leading-relaxed">
                  <li>Google Chrome</li>
                  <li>Mozilla Firefox</li>
                  <li>Apple Safari</li>
                  <li>Microsoft Edge</li>
                </ul>
              </div>
              <div className="bg-muted/30 p-4 rounded-md border border-border mt-4">
                <p className="text-sm font-sans text-foreground/80 leading-relaxed">
                  <strong>Nota Bene:</strong> La disattivazione dei cookie, specialmente quelli tecnici, potrebbe limitare le funzionalità del sito e impedirti di completare gli acquisti correttamente.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="font-default text-2xl font-bold text-foreground mb-4">
              5. Cookie di Terze Parti
            </h2>
            <p className="font-sans text-foreground/80 leading-relaxed mb-4">
              In alcune sezioni del sito, terze parti potrebbero impostare i propri cookie anonimi per monitorare il successo delle loro applicazioni o personalizzarle per te. Esempi includono:
            </p>
            <ul className="list-disc pl-6 space-y-2 font-sans text-foreground/80 leading-relaxed mb-4">
              <li>Servizi di analisi statistica (es: Google Analytics).</li>
              <li>Integrazioni social (es: pulsanti di condivisione Facebook, Instagram).</li>
              <li>Piattaforme pubblicitarie esterne.</li>
            </ul>
            <p className="font-sans text-foreground/80 leading-relaxed">
              Non abbiamo accesso a questi cookie, né le terze parti hanno accesso ai dati dei cookie utilizzati da noi. Ti invitiamo a consultare le informative sulla privacy di tali soggetti terzi.
            </p>
          </section>

          <section>
            <h2 className="font-default text-2xl font-bold text-foreground mb-4">
              6. Durata dei Cookie
            </h2>
            <p className="font-sans text-foreground/80 leading-relaxed mb-4">
              In base alla loro durata, utilizziamo due tipologie di cookie:
            </p>
            <ul className="list-disc pl-6 space-y-2 font-sans text-foreground/80 leading-relaxed">
              <li><strong>Cookie di sessione:</strong> Sono temporanei e restano nel browser fino alla chiusura della finestra. Servono per analizzare i modelli di traffico e risolvere eventuali problemi tecnici in tempo reale.</li>
              <li><strong>Cookie persistenti:</strong> Rimangono memorizzati sul tuo dispositivo e vengono attivati ogni volta che torni a trovarci, per offrirti un servizio più veloce e personalizzato.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-default text-2xl font-bold text-foreground mb-4">
              7. Consenso
            </h2>
            <p className="font-sans text-foreground/80 leading-relaxed mb-4">
              Utilizzando il nostro sito e accettando questa informativa, acconsenti all'uso dei cookie secondo le modalità qui descritte.
            </p>
            <ul className="list-disc pl-6 space-y-2 font-sans text-foreground/80 leading-relaxed">
              <li>Il consenso per i cookie non essenziali è facoltativo e revocabile in ogni momento.</li>
              <li>Puoi modificare le tue scelte attraverso le impostazioni del browser o il pannello di gestione cookie sul sito.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-default text-2xl font-bold text-foreground mb-4">
              8. Modifiche all'Informativa
            </h2>
            <p className="font-sans text-foreground/80 leading-relaxed">
              Ci riserviamo il diritto di aggiornare questa Informativa sui Cookie in qualsiasi momento per riflettere cambiamenti nelle normative o nelle nostre pratiche aziendali. Ti consigliamo di consultare periodicamente questa pagina.
            </p>
          </section>

          <section>
            <h2 className="font-default text-2xl font-bold text-foreground mb-4">
              9. Contatti
            </h2>
            <p className="font-sans text-foreground/80 leading-relaxed mb-2">
              Se hai domande sulla nostra gestione dei cookie o sulla privacy, non esitare a contattarci:
            </p>
            <ul className="list-none space-y-2 font-sans text-foreground/80 leading-relaxed">
              <li><strong>Azienda:</strong> Dolci Sapori</li>
              <li><strong>Email:</strong> info@dolcisapori.eu</li>
              <li><strong>Sede:</strong> Sciacca (AG), Sicilia</li>
            </ul>
          </section>

          <section>
            <h2 className="font-default text-2xl font-bold text-foreground mb-4">
              10. Risoluzione delle Controversie
            </h2>
            <p className="font-sans text-foreground/80 leading-relaxed">
              In caso di controversie, il consumatore può ricorrere alla Piattaforma Europea per la Risoluzione delle Controversie Online o alle autorità competenti. Per maggiori informazioni, consulta il portale del Garante per la Protezione dei Dati Personali su{" "}
              <Link to="https://www.garanteprivacy.it" newTab className="text-chart-2 hover:underline font-medium">
                www.garanteprivacy.it
              </Link>.
            </p>
          </section>

        </div>
      </div>
    </section>;
}